namespace App {
    export class StorageLocal {

        public updateOrCreateArrayItens(chaveStorage: string, itensOuItem: any, keyId: string = "id") {
            if (!chaveStorage) {
                return;
            }

            let oldItensArray = this.getArrayItensOrItem(chaveStorage);
            if ($.isArray(itensOuItem)) {
                store.set(chaveStorage, itensOuItem)
            } else {
                store.set(chaveStorage, App.Util.updateOrCreateItemArrayCustomId(oldItensArray, itensOuItem[keyId], itensOuItem, keyId))
            }
        }

        public getArrayItensOrItem(chaveStorage: string, id: any = null, keyId: string = "id") {
            if (!chaveStorage) {
                return;
            }
            let resultStorage = store.get(chaveStorage) || []
            if (id) {
                return App.Util.getItemArrayByCustomId(resultStorage, id, keyId) || null
            }
            return resultStorage;
        }

        private clearStorageArray(chaveStorage: string) {
            if (!chaveStorage) {
                return;
            }
            return store.set(chaveStorage, []);
        }
    }
}
